import { FC } from 'react';
import Image from 'next/image';

import styles from './business-hub-industries-optional-quote.module.scss';
import classNames from 'classnames';

export interface IndustriesOptionalQuoteProps {
    quote?: string;
    author?: string;
    illustration?: string;
    background?: string;
    textColor?: string;
    textSize?: 'default' | 'small';
    reversed?: boolean;
    hideIllustrationOnMobile?: boolean;
    gridTemplateColumns?: string;
}

const BusinessHubIndustriesOptionalQuote: FC<IndustriesOptionalQuoteProps> = (props) => {
    const { quote, author, illustration, background, textColor, textSize, reversed, hideIllustrationOnMobile, gridTemplateColumns } = props;

    return (
        <div className={styles.container} style={{ '--bg-color': background, '--text-color': textColor } as React.CSSProperties}>
            <div className={classNames(styles.gird, { [styles.reversed]: reversed })} style={{ '--grid-template-columns': gridTemplateColumns } as React.CSSProperties}>
                <div className={styles.content}>
                    <div className={classNames(styles.quote, { [styles.small]: textSize === 'small' })} dangerouslySetInnerHTML={{ __html: quote || '' }} />
                    <div className={styles.author} dangerouslySetInnerHTML={{ __html: author || '' }} />
                </div>
                <div className={classNames(styles.illustration, { [styles.desktop]: hideIllustrationOnMobile })}>
                    {illustration && <img alt="" src={illustration} style={{ objectFit: 'cover', objectPosition: 'bottom' }} />}
                </div>
            </div>
        </div>
    );
};

export default BusinessHubIndustriesOptionalQuote;
